import { NoConnectionService } from './no-connection.service';
import { Component } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-no-connection',
  standalone: true,
  imports: [ButtonComponent, TranslateModule, CommonModule],
  templateUrl: './no-connection.component.html',
  styleUrls: ['./no-connection.component.scss'],
})
export class NoConnectionComponent {
  isLoading = false;
  isOffline = true;

  constructor(private noConnectionService: NoConnectionService) {}

  checkNetworkStatus() {
    this.isLoading = true;
    setTimeout(() => {
      this.noConnectionService.isOffline.next(!navigator.onLine);
      this.isLoading = false;
    }, 1000);
  }
}
